import { injectIntl } from 'react-intl';

import FareConditions from './FareConditions';

export default injectIntl(FareConditions);
